import { render } from "./KudosStripePage.vue?vue&type=template&id=e7d3ca5e&scoped=true"
import script from "./KudosStripePage.vue?vue&type=script&lang=js"
export * from "./KudosStripePage.vue?vue&type=script&lang=js"

import "./KudosStripePage.vue?vue&type=style&index=0&id=e7d3ca5e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7d3ca5e"]])

export default __exports__